import React, { useState } from "react";
import "./ContactUs.css";
import { ApiUrl } from "../../../Admin/API/ApiUrl";
import Swal from "sweetalert2";

export default function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

    // Clear error when user types again
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const nameRegex = /^[A-Za-z\s.]+$/;
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|edu|gov|in)$/;
  const subjectRegex = /^[A-Za-z0-9\s.,-]+$/;
  const messageRegex = /^[A-Za-z0-9\s.,!?-]+$/;



  const validateForm = () => {
    const newErrors = {};

    // Name
    if (!formData.name.trim()) {
      newErrors.name = "Full Name is required";
    } else if (!nameRegex.test(formData.name)) {
      newErrors.name = "Only letters allowed in name";
    } else if (formData.name.trim().length < 3) {
      newErrors.name = "Name must be at least 3 characters";
    }

    // Email
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    // Subject
    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required";
    } else if (!subjectRegex.test(formData.subject)) {
      newErrors.subject = "No special characters allowed in subject";
    } else if (formData.subject.length < 5) {
      newErrors.subject = "Subject must be at least 5 characters";
    }

    // Message
    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    } else if (!messageRegex.test(formData.message)) {
      newErrors.message = "Invalid characters in message";
    } else if (formData.message.trim().length < 10) {
      newErrors.message = "Message must be at least 10 characters long";
    }

    // console.log("🛑 Validation Errors:", newErrors);

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length !== 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await fetch(`${ApiUrl}/contact-messages`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }

      Swal.fire({
        icon: "success",
        title: "Message Sent",
        text: data.message || "Your message has been sent successfully!",
        confirmButtonColor: "#3085d6",
        timer: 4000,
      });

      setErrors({});
      setFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });

    } catch (error) {
      console.error("Submission Error:", error);

      // ❌ Error Alert
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong!",
      });

      setErrors({ api: error.message });
    }
  };

  return (
    <div className="contactUs-page-wrapper">
      <header className="contactUs-header">
        <h1 className="contactUs-heading">Get in Touch</h1>
        <p className="contactUs-subheading">
          Have questions or want to collaborate? We’d love to hear from you.
        </p>
      </header>

      <section className="contactUs-body">
        <div className="contactUs-infoCard">
          <h2 className="contactUs-infoTitle">Chief Editor</h2>
          <p className="contactUs-infoName">Mr. S. Ratheesh</p>
          <div className="contactUs-divider"></div>

          <div className="contactUs-detailItem">
            <span className="contactUs-label">Mobile</span>
            <span className="contactUs-value">+91-7402616151</span>
          </div>
          <div className="contactUs-detailItem">
            <span className="contactUs-label">Email</span>
            <span className="contactUs-value">ijacna@gmail.com</span>
          </div>
        </div>

        <form className="contactUs-formCard" onSubmit={handleSubmit}>
          <div className="contactUs-formGroup">
            <label className="contactUs-formLabel">Full Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={formData.name}
              onChange={handleChange}
              className={`contactUs-input ${errors.name ? "error" : ""}`}
            />
            {errors.name && (
              <span className="contactUs-error">{errors.name}</span>
            )}
          </div>

          <div className="contactUs-formGroup">
            <label className="contactUs-formLabel">Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              className={`contactUs-input ${errors.email ? "error" : ""}`}
            />
            {errors.email && (
              <span className="contactUs-error">{errors.email}</span>
            )}
          </div>

          <div className="contactUs-formGroup">
            <label className="contactUs-formLabel">Subject</label>
            <input
              type="text"
              name="subject"
              placeholder="Enter the subject"
              value={formData.subject}
              onChange={handleChange}
              className={`contactUs-input ${errors.subject ? "error" : ""}`}
            />
            {errors.subject && (
              <span className="contactUs-error">{errors.subject}</span>
            )}
          </div>

          <div className="contactUs-formGroup">
            <label className="contactUs-formLabel">Message</label>
            <textarea
              name="message"
              placeholder="Write your message here..."
              value={formData.message}
              onChange={handleChange}
              className={`contactUs-textarea ${errors.message ? "error" : ""}`}
              rows="5"
            />
            {errors.message && (
              <span className="contactUs-error">{errors.message}</span>
            )}
          </div>

          <button type="submit" className="contactUs-submitButton">
            Send Message
          </button>

          {/* {submitted && (
            <p className="contactUs-successMsg">
              ✅ Thank you! Your message has been sent successfully.
            </p>
          )} */}
        </form>
      </section>
    </div>
  );
}
